__turbopack_context__.v({
  "faq": "index-module-scss-module__TIcIVq__faq",
  "judge": "index-module-scss-module__TIcIVq__judge",
  "judgeDescription": "index-module-scss-module__TIcIVq__judgeDescription",
  "judgeName": "index-module-scss-module__TIcIVq__judgeName",
  "judgePhoto": "index-module-scss-module__TIcIVq__judgePhoto",
  "loading": "index-module-scss-module__TIcIVq__loading",
  "logo": "index-module-scss-module__TIcIVq__logo",
  "overlay": "index-module-scss-module__TIcIVq__overlay",
  "question": "index-module-scss-module__TIcIVq__question",
});
